import React from 'react'
import ReactDOM from 'react-dom'
import BodyComponent from '../bodycomponent'
import Intro from '../intro/intro'
import ContactForm from '../contact-form/contact-form'
import MyImageGallery from '../MyImageGallery.js'
// import MyVideoGallery from '../MyVideoGallery.js'
import Helmet from 'react-helmet'
import Snippet from './snippet'

// import EventLayouter from './eventlayouter'
import PersonPresenter from './personpresenter'

function importAll(r) {
    return r.keys().map(r);
  }

// const images = importAll(require.context('../', false, /\.(png|jpe?g|svg)$/));
const snippets = importAll(require.context('../snippets/', false, /\.(mp3)$/));

class MainpageBody extends BodyComponent {
    constructor(props) {
        super(props);
        this.currentSection = -1;
        this.loaded = 0;
    }

    onImgLoaded(id) {
        this.loaded++;
        if (this.loaded >= 3) {
            this.props.resizeScreen();
            // console.log("Resizing screen. Done Loading!");
            this.loaded = 0;
        }
    }

    componentDidMount() {
        this.props.setHeaderSections(['Über uns', 'Hörproben', 'Galerie', 'Kontakt']);
        while (this.props.scrollHandler.length > 0)
            this.props.scrollHandler.pop();
        this.props.scrollHandler.push(this.handleScroll.bind(this));
    }

    handleScroll() {
        for (let i = this.props.links.length - 1; i >= 0; i--) {
            const element = this.props.links[i];
            const rect = ReactDOM.findDOMNode(this.refs['h1' + element]).getBoundingClientRect();
            const pos = rect.y || rect.top;
            if (pos < 150) {
                this.props.setHighlightedSection(i);
                return;
            }
        }
        this.props.setHighlightedSection(-1);
    }

    render() {
        this.currentSection = -1;
        return (
            <div>
                <Helmet>
                    <title>Pluspunkt Musik</title>
                    <meta name="description" content="Helmet application" />
                </Helmet>
                <Intro imgResIndex={this.props.imgResIndex} onImgLoaded={this.onImgLoaded.bind(this)} />

                {this.renderNextSection()}
                <PersonPresenter imgResIndex={this.props.imgResIndex} onImgLoaded={this.onImgLoaded.bind(this)} />

                {this.renderNextSection()}
                {/* <h2>Hörproben</h2> */}
                <ul className="Snippet">
                {
                    snippets.map((url, i) => <Snippet id={i} url={url}/>)
                }
                </ul>

                {/* {this.renderNextSection()} */}
                {/* <MyVideoGallery imgResIndex={this.props.imgResIndex} /> */}
                {/* <p>
                    Leider sind viele der kommenden Veranstaltungen private Feiern und deshalb nicht hier gelistet. <br />
                    Vielleicht habt auch Ihr einen Grund zum feiern? <a href="#kontakt">Dann meldet euch bei uns</a>.
                </p> */}
                {/* <EventLayouter imgResIndex={this.props.imgResIndex} onImgLoaded={this.onImgLoaded.bind(this)} /> */}

                {this.renderNextSection()}
                <MyImageGallery imgResIndex={this.props.imgResIndex} onImgLoaded={this.onImgLoaded.bind(this)} />

                {this.renderNextSection()}
                <p>
                    Ihr seid interessiert, habt noch allgemeine Fragen, braucht eine Beratung oder wollt erstmal nur unverbindlich mit uns in Kontakt treten? <br />
                    Nutzt gerne das Kontaktformular für euer Anliegen und wir melden uns schnellstmöglich.
                </p>
                <p style={{ fontWeight: 'bold', color: '#f7991e' }}>
                    Wir freuen uns auf jede Anfrage.
                </p>

                <ContactForm />
            </div>
        );
    }
}

export default MainpageBody



// WEBPACK FOOTER //
// ./src/mainpage-body/mainpage-body.js